var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkdin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_157_669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5292 3.00452C4.5903 3.00452 3.00342 4.59136 3.00342 6.5303V17.4714C3.00342 19.4103 4.59026 20.9967 6.5292 20.9967H17.4703C19.4093 20.9967 20.9956 19.4104 20.9956 17.4714V6.5303C20.9956 4.5914 19.4093 3.00452 17.4703 3.00452H6.5292ZM7.41599 5.97358C8.34566 5.97358 8.91829 6.58389 8.93597 7.38613C8.93597 8.17066 8.34562 8.79812 7.39801 8.79812H7.38057C6.4686 8.79812 5.87915 8.1707 5.87915 7.38613C5.87915 6.58391 6.48644 5.97358 7.41597 5.97358H7.41599ZM15.4274 9.72316C17.2154 9.72316 18.5557 10.8918 18.5557 13.403V18.0911H15.8385V13.7173C15.8385 12.6182 15.4453 11.8684 14.4619 11.8684C13.7113 11.8684 13.2638 12.3738 13.0674 12.862C12.9956 13.0367 12.978 13.2807 12.978 13.525V18.0911H10.2608C10.2608 18.0911 10.2965 10.6821 10.2608 9.9149H12.9785V11.0727C13.3396 10.5156 13.9855 9.72314 15.4274 9.72314V9.72316ZM6.03942 9.91549H8.75658V18.0911H6.03942V9.91549Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_157_669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.02c3b876d7586e0481c7871982aa2fa5.svg";
export { ForwardRef as ReactComponent };